module.exports = __webpack_public_path__ + "id_5.d72e036ffeb153b814fce1cb4ec1cf47.svg";